import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const AllRules: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div></div>;
  }

  if (!currentUser) {
    if (location.pathname !== "/login") {
      return <Navigate to="/login" />;
    }
  } else if (location.pathname === "/login") {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default AllRules;
